export default __webpack_public_path__ + "static/media/2256.4b4fcf72.png";